export const cutString = (text: string, limit: number) => {
  return text && text.length > limit
    ? text.substring(0, limit - 3) + "..."
    : text;
};
